'use client';

import { Session } from '@pickleballinc/lib/session';
import { isSameUuid } from '@pickleballinc/lib/uuid-utils';

import { useAuthorizeDashboard } from '@/modules/players/v3/hooks/use-authorize-dashboard';
import { PlayerData } from '@/types/players.types';

interface UsePlayerHeaderActionsParams {
  playerData: PlayerData | undefined;
  user: Session | undefined;
  isProPlayer: boolean | undefined;
  currentUserIsProPlayer: boolean | undefined;
}

interface PlayerHeaderActions {
  isUserVisitingOwnProfile: boolean;
  canSeeMyDashboard: boolean;
  canSeeFriendActions: boolean;
  canSeeFollowActions: boolean;
}

export const usePlayerHeaderActions = ({
  playerData,
  user,
  isProPlayer,
  currentUserIsProPlayer,
}: UsePlayerHeaderActionsParams): PlayerHeaderActions => {
  const isUserVisitingOwnProfile = isSameUuid(playerData?.uuid, user?.uuid);
  const canSeeMyDashboard = useAuthorizeDashboard(isUserVisitingOwnProfile);

  // Amateurs can't friend a pro — the API coerces that request into a follow. Everyone else can.
  // Follow stays offered for any pro target, so pro → pro can friend, follow, or both.
  const isAmateurViewingPro = !currentUserIsProPlayer && !!isProPlayer;

  return {
    isUserVisitingOwnProfile,
    canSeeMyDashboard,
    canSeeFriendActions: !isUserVisitingOwnProfile && !isAmateurViewingPro,
    canSeeFollowActions: !isUserVisitingOwnProfile && !!isProPlayer,
  };
};
